import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-no-permission',
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss']
})
export class NoPermissionComponent {

}
